import { useEffect, useState } from "react";
import { InfoBox } from "../../../ui/molecules/infoBox";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { AssignmentUpdate, GetAllAssignment, setAssCreationAssignmentPlace, setAssUpdateAssignmentPlace, setAssUpdateDepartureProtocolId, setAssUpdatePMContractId, setAssUpdateReference, setAssUpdateRevocationProtocolId, setAssUpdateSignedAssignmentLetterId, setAssUpdateState } from "../slice";
import { SelectCustom } from "../../../ui/molecules/select";
import { ProtocolSearch } from "../../../ui/molecules/ProtocolSearch";
import Button from "../../../ui/molecules/button";
import Input from "../../../ui/molecules/input";
import { AssignmentStateOptions, OptionType } from "../../../utils";
import { GetAllContracts, resetGetAllContractsStatus } from "../../gestionePersonale/boxContratti/slice";
import { GetHeadQuarter } from "../../sot/slice";

export function EditAssignmentPopup() {
    const dispatch = useAppDispatch()
    const assignmentState = useAppSelector(state => state.assignment)
    const pmContractState = useAppSelector(state => state.PMContracts)
    const [contracts, setContracts] = useState<OptionType[]>([])
    const [placeOptions, setPlaceOptions] = useState<OptionType[]>([])
    const sotState = useAppSelector(state => state.headQuarter)

    useEffect(() => {
        dispatch(GetHeadQuarter({
            itemsPerPage: 0,
            page: 0
        }))
    }, [])

    useEffect(() => {
        if (assignmentState.assignmentPMId !== '')
            dispatch(GetAllContracts({
                itemsPerPage: 0,
                page: 0,
                personalManagementId: assignmentState.assignmentPMId
            }))
    }, [assignmentState.assignmentPMId])

    useEffect(() => {
        if (sotState.responseHeadQuarterStatus === 'successfully' &&
            sotState.responseHeadQuarter !== undefined
        ) {
            const data = sotState.responseHeadQuarter.data.map(hq => {
                return {
                    value: `${hq.city} (${hq.province})`,
                    label: `${hq.city} (${hq.province})`
                } as OptionType
            })

            setPlaceOptions(data)
        }
    }, [sotState.responseHeadQuarterStatus])

    useEffect(() => {
        if (pmContractState.getAllContractsStatus === 'successfully' &&
            pmContractState.getAllContractsResponse !== undefined
        ) {
            dispatch(resetGetAllContractsStatus())
            const data = pmContractState.getAllContractsResponse.data.map(c => {
                return {
                    value: c.id,
                    label: `${c.contractType}, ${c.starting} - ${c.ending ? c.ending : ' - '}`
                } as OptionType
            })

            setContracts(data)
        }
    }, [pmContractState.getAllContractsStatus])

    return (
        <div style={{ padding: '24px 24px 18px 24px' }}>
            <div>
                <div className='pb-5 pt-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div className="pb-5">
                        <div className='text-left assignment-text-bold'>
                            Protocollo Incarico
                        </div>
                        <ProtocolSearch
                            value={assignmentState.assignmentUpdateRequest.departureProtocolId ? assignmentState.assignmentUpdateRequest.departureProtocolId : undefined}
                            type='departure'
                            onSelect={(value) => dispatch(setAssUpdateDepartureProtocolId(value))}
                        />
                    </div>

                </div>
                <div className='pb-5 pt-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left assignment-text-bold'>
                            Luogo di Assegnazione
                        </div>

                        <SelectCustom
                            error={assignmentState.assignmentErrors.assignmentPlace}
                            errorLabel='Luogo mancante'
                            placeholder='Seleziona luogo...'
                            options={placeOptions}
                            value={assignmentState.assignmentUpdateRequest.assignmentPlace}
                            onChange={(value) => dispatch(setAssUpdateAssignmentPlace(value))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left assignment-text-bold'>
                            Stato
                        </div>
                        <SelectCustom
                            placeholder='Seleziona stato...'
                            options={AssignmentStateOptions}
                            value={assignmentState.assignmentUpdateRequest.state}
                            onChange={(value) => {
                                dispatch(setAssUpdateState(value))
                            }}
                        />
                    </div>
                </div>

                <div className="pb-5">
                    <div className='text-left assignment-text-bold'>
                        Protocollo Revoca (Compilare solo in caso di revoca del contratto)
                    </div>
                    <ProtocolSearch
                        value={assignmentState.assignmentUpdateRequest.revocationProtocolId ? assignmentState.assignmentUpdateRequest.revocationProtocolId : undefined}
                        type='departure'
                        onSelect={(value) => dispatch(setAssUpdateRevocationProtocolId(value))}
                    />
                </div>

                <div className="pb-5">
                    <div className='text-left assignment-text-bold'>
                        Restituzione lettera incarico firmata
                    </div>
                    <ProtocolSearch
                        value={assignmentState.assignmentUpdateRequest.signedAssignmentLetterId ? assignmentState.assignmentUpdateRequest.signedAssignmentLetterId : undefined}
                        type='departure'
                        onSelect={(value) => dispatch(setAssUpdateSignedAssignmentLetterId(value))}
                    />
                </div>

                <div style={{ display: 'flex', gap: '24px', justifyContent: 'flex-end' }}>
                    <Button
                        variant="solid"
                        color="orange"
                        size="md"
                        iconPosition="off"
                        label="Salva"
                        onClick={() =>
                            dispatch(AssignmentUpdate(
                                {
                                    body: assignmentState.assignmentUpdateRequest, id: assignmentState.assignmentIdToUpdate
                                }))
                        }
                    />
                </div>
            </div>
        </div>
    )
}